module.exports = __webpack_public_path__ + "static/media/Brad Collins.61f5c789.png";